<template>
    <b-form-group :label="$t('daily.dueDate')">
        <date-picker
            :value="value"
            :locale="locale"
            timezone="UTC"
            :first-day-of-week="1"
            nav-visibility="click"
            :popover="{ visibility: 'click' }"
            :showDayPopover="false"
            @input="$emit('input', $event)"
            :min-date="minDate"
        >
            <template v-slot="{ inputValue, inputEvents }">
                <b-form-input :value="inputValue" v-on="inputEvents" :placeholder="placeholder" />
            </template>
        </date-picker>
    </b-form-group>
</template>
<script>
import { DatePicker } from 'v-calendar'
import i18n from '@/i18n'

export default {
    components: {
        DatePicker,
    },
    props: {
        value: null,
        placeholder: null,
        minDate: null,
    },
    computed: {
        locale() {
            return i18n.locale
        },
    },
}
</script>
